// extracted by mini-css-extract-plugin
module.exports = {"main":"ChatImageMessageUpload_main__1-OEt"};